import 'rxjs/add/operator/map';
import {error} from "util";


export class SGTIN96 {

  private uriPrefix: string = "urn:epc:tag:sgtin-96:";
  private _header: number = 48; // 8-bits
  private filterValueMin: number = 0;
  private filterValueMax: number = 7;
  private filterValue: number = 1;

  private partitionValueMin: number = 0;
  private partitionValueMax: number = 6;
  // Company prefix value
  private companyPrefix: number; // 20-40 bits; default 24-bits, per partition
  private companyPrefixLengthInBits: number = 24;
  private companyPrefixLengthInDigits: number = 7;

  // Item reference value
  private itemReference: number; // 24-4 bits; default 20-bits, per partition
  private itemReferenceLengthInBits: number = 20;
  private itemReferenceLengthInDigits: number = 6;

  // Item UPC
  private upc: string;
  private upcCheckDigit: number;

  // Serial number value
  private serialNumber: number; // 38 bits
  private serialNumberMaxBits: number = 38;

  private CONVERTHEX: number = 16;
  private CONVERTDECIMAL: number = 10;
  private CONVERTBINARY: number = 2;

  constructor() {
    console.log('Hello SGTIN96 Provider');
  }

  private partition: number = 5; // 3 bits


  public getHeader(): number {
    return this._header;
  }

  public setHeader(value: number) {
    this._header = value;
  }

  public getFilterValue(): number {
    return this.filterValue;
  }

  public setFilterValue(filterValue: number): void {
    this.filterValue = filterValue;
  }

  public getPartition(): number {
    return this.partition;
  }

  public setPartition(partition: number): void {
    this.partition = partition;
  }

  public getCompanyPrefix(): number {
    return this.companyPrefix;
  }

  public setCompanyPrefix(companyPrefix: number): void {
    this.companyPrefix = companyPrefix;
  }

  public getItemReference(): number {
    return this.itemReference;
  }

  public setItemReference(itemReference: number): void {
    this.itemReference = itemReference;
  }

  public getUpc(): string {
    return this.upc;
  }

  public setUpc(upc: string): void {
    this.upc = upc;
  }

  public getSerialNumber(): number {
    return this.serialNumber;
  }

  public setSerialNumber(serialNumber: number): void {
    this.serialNumber = serialNumber;
  }


  fromString(Sgtin96AsString: string) {
    let sgtin96: SGTIN96;

    if (!Sgtin96AsString) {
      throw  new Error("empty string found")
    }

    if (this.isValidUri(Sgtin96AsString)) {
      // It is a URI String, so populate the object data members
      // accordingly
      try {
        sgtin96 = this.fromSgtin96Uri(Sgtin96AsString);
      }
      catch (ex) {
        throw ex;
      }
    }
    else if (this.IsValidEpc(Sgtin96AsString)) {
      // It is an EPC String, so populate the object data members
      // accordingly
      try {
        sgtin96 = this.fromSgtin96Epc(Sgtin96AsString);
      }
      catch (ex) {
        throw ex;
      }
    }
    else {
      throw new Error("Invalid SGTIN-96 String");
    }

    return sgtin96;
  }

  private fromSgtin96Uri(Uri: string): SGTIN96 {
    let sgtin96: SGTIN96 = new SGTIN96();
    let localUri: string = Uri;
    let dataValues: string[];

    if (this.isValidUri(Uri)) {
      // Strip out the fixed URI prefix String so that we can look at the data
      let DataFields: string = localUri.replace(this.uriPrefix, "");
      // Now, extract each of the remaining fields as a separate String
      dataValues = DataFields.split(".");

      // Extract the Filter value
      sgtin96.filterValue = parseInt(dataValues[0]);
      // Extract the Company Prefix value
      sgtin96.companyPrefix = parseInt(dataValues[1]);
      // Extract the Item Reference Value
      sgtin96.itemReference = parseInt(dataValues[2]);
      // Calculate the Partition value from the number of
      // digits in the Item Reference field
      sgtin96.partition = (dataValues[2].length - 1);
      // Populate the Digit and Bit length fields for the
      // Company Prefix and Item Reference values
      this.SetLengthsFromPartition(sgtin96);
      // Extract the serial number
      sgtin96.serialNumber = parseInt(dataValues[3]);
      // Add company prefix digits, less the first '0' character,
      // which is added in the UPC to GTIN conversion
      sgtin96.upc = this.formatZeroFilled(sgtin96.companyPrefix, sgtin96.companyPrefixLengthInDigits - 1);
      // If the number of companyPrefix digits is less than 12, then
      // Add item reference digits, less the first '0' character,
      // which is added in the UPC to GTIN conversion
      if (12 > sgtin96.companyPrefixLengthInDigits) {
        sgtin96.upc += this.formatZeroFilled(sgtin96.itemReference, sgtin96.itemReferenceLengthInDigits - 1);

      }

      sgtin96.upcCheckDigit = this.CalculateUpcCheckDigit(sgtin96.upc);
    }
    else {
      throw new Error("Invalid SGTIN-96 URI");
    }

    return sgtin96;
  }


  public fromSgtin96Epc(epc: string): SGTIN96 {
    let returnSgtin96: SGTIN96 = new SGTIN96();
    let epcToValidate: string = "";

    if (epc) {
      epcToValidate = epc.replace(" ", "");
    }
    else {
      throw new Error("null SGTIN-96 EPC");
    }

    if (this.IsValidEpc(epcToValidate)) {
      let bigInt = require("big-integer");
      let BinaryEpc: string = this.padLeft(bigInt(epcToValidate, this.CONVERTHEX).toString(this.CONVERTBINARY), 96, '0');
      // Extract the Filter Value
      returnSgtin96.filterValue = parseInt(BinaryEpc.substring(8, 8 + 3), this.CONVERTBINARY);
      // Extract the Partition Value
      returnSgtin96.partition = parseInt(BinaryEpc.substring(11, 11 + 3), this.CONVERTBINARY);
      // Populate the Digit and Bit length fields for the
      // Company Prefix and Item Reference values
      this.SetLengthsFromPartition(returnSgtin96);

      // Extract the Company Prefix
      returnSgtin96.companyPrefix =
        parseInt(BinaryEpc.substring(14, returnSgtin96.companyPrefixLengthInBits + 14), 2);
      // Extract the Item Reference
      returnSgtin96.itemReference =
        parseInt(BinaryEpc.substring(14 + returnSgtin96.companyPrefixLengthInBits, 14 + returnSgtin96.companyPrefixLengthInBits + returnSgtin96.itemReferenceLengthInBits), 2);
      // Extract the Serial number
      returnSgtin96.serialNumber =
        parseInt(BinaryEpc.substring(58, 58 + 38), 2);
      // Add company prefix digits, less the first '0' character,
      // which is added in the UPC to GTIN conversion
      returnSgtin96.upc = this.formatZeroFilled(returnSgtin96.companyPrefix, returnSgtin96.companyPrefixLengthInDigits - 1);
      // If the number of companyPrefix digits is less than 12, then
      // Add item reference digits, less the first '0' character,
      // which is added in the UPC to GTIN conversion
      if (12 > returnSgtin96.companyPrefixLengthInDigits) {
        returnSgtin96.upc += this.formatZeroFilled(returnSgtin96.itemReference, returnSgtin96.itemReferenceLengthInDigits - 1);
      }

      // Now calculate the UPC check digit
      returnSgtin96.upcCheckDigit = this.CalculateUpcCheckDigit(returnSgtin96.upc);
    }
    else {
      return null;
    }

    return returnSgtin96;

  }
  public fromUPCwithValues(UPC: string, companyPrefixLength: number, partition: number, headerValue: number, filterValue: number, serialNumber: number): SGTIN96 {
  this._header = headerValue;
    if (0 <= filterValue && filterValue <= 7) {
      this.filterValue = filterValue;
    } else {
      throw error("invalid filter value");
    }
  this.partition = partition;
  this.serialNumber = serialNumber;
  return this.fromUPC(UPC, companyPrefixLength);
  }
  public fromUPC(UPC: string, companyPrefixLength: number): SGTIN96 {

    let returnSgtin96: SGTIN96 = null;

    let uriRepresentation: string = "";

    // Verify that the provided UPC is valid
    if (this.IsValidGtin(UPC)) {
      // Build an appropriate URI String.
      // First, add the prefix:
      uriRepresentation += (this.uriPrefix);
      // append the filter value:
      uriRepresentation += (this.filterValue + ".");
      // Extract the company prefix. As a '0' prefix is added to
      // make up the correct number of company prefix digits,
      // per the GS1 standard, we extract one less character than
      // is defined by companyPrefixLength.
      // Ref: http://www.gs1us.org/DesktopModules/Bring2mind/DMX/Download.aspx?EntryId=361&Command=CoreDownload&PortalId=0&TabId=73
      uriRepresentation += UPC.substring(1, companyPrefixLength + 1);
      // append the period delimiter:
      uriRepresentation += (".");
      // Add an Indicator Digit value of '0' to indicate item level
      // packaging.
      uriRepresentation += ('0');
      // Add the Item Reference Number, skipping the check digit at the end
      uriRepresentation += UPC.substring(companyPrefixLength + 1, UPC.length -1);
      if (this.serialNumber) {
        // append a zero-value serial number
          uriRepresentation += ("." + this.serialNumber);
      } else {
        uriRepresentation += (".0");
      }
      // Now create SGTIN using the FromUri API:
      returnSgtin96 = this.fromSgtin96Uri(uriRepresentation.toString());
    }
    else {
      throw (new Error("Invalid UPC String."));
    }
    return returnSgtin96;
  }


  public fromGTIN(Gtin: string, companyPrefixLength: number): SGTIN96 {
    let ReturnSgtin96: SGTIN96 = new SGTIN96();
    let gtinLessFillerDigit: string = Gtin.substring(1, Gtin.length - 1);
    let UriRepresentation: string = "";

    // Verify that the provided UPC is valid
    if (this.IsValidGtin(Gtin)) {
      // Build an appropriate URI String.
      // First, add the prefix:
      UriRepresentation += (this.uriPrefix);
      // append the filter value:
      UriRepresentation += (this.filterValue + ".");
      // Extract the company prefix
      UriRepresentation += (gtinLessFillerDigit.substring(0, companyPrefixLength));
      // append the period delimiter:
      UriRepresentation += (".");
      // Add an Indicator Digit value of '0' to indicate item level
      // packaging.
      UriRepresentation += ('0');
      // Add the Item Reference Number, skipping the check digit at the end
      let ItemReferenceDigitCount: number = (gtinLessFillerDigit.length - companyPrefixLength) - 1;
      UriRepresentation += (gtinLessFillerDigit.substring(companyPrefixLength, ItemReferenceDigitCount));
      // append a zero-value serial number
      UriRepresentation += (".0");
      // Now create SGTIN using the FromUri API:
      ReturnSgtin96 = this.fromSgtin96Uri(UriRepresentation.toString());
    }
    else {
      throw (new Error("Invalid GTIN String."));
    }

    return ReturnSgtin96;
  }

  public toString(): string {
    return this.ToUri();
  }

  public ToUri(): string {
    // Placeholder for building URI String
    let sgtinUri: string = "";

    // Add the URI prefix
    sgtinUri += (this.uriPrefix);
    // append the Filter Value
    sgtinUri += (this.filterValue);
    // Add the '.' delimiter
    sgtinUri += (".");

    // append the Company Prefix
    sgtinUri += (this.padLeft(this.companyPrefix.toString(), this.companyPrefixLengthInDigits, '0'));
    // Add the '.' delimiter
    sgtinUri += (".");
    // append the Item Reference
    sgtinUri += ( this.padLeft(this.itemReference.toString(), this.itemReferenceLengthInDigits, '0'));
    // Add the '.' delimiter
    if (this.serialNumber) {
      sgtinUri += (".");
      // append the Serial Number
      sgtinUri += (this.serialNumber.toString());
    }
    // Return the URI String
    return sgtinUri;
  }

  public ToEpc(): string {
    // Placeholder for a binary representation of the EPC
    let binarySgtinEpc: string = "";

    // Add the SGTIN-96 header in binary format
    binarySgtinEpc += (this.padLeft(this._header.toString(this.CONVERTBINARY), 8, '0'));
    // append the Filter Value in binary format
    binarySgtinEpc += (this.padLeft(this.filterValue.toString(this.CONVERTBINARY), 3, '0'));
    // append the Partition in binary format
    binarySgtinEpc += (this.padLeft(this.partition.toString(this.CONVERTBINARY), 3, '0'));
    // append the Company Prefix
    binarySgtinEpc += (this.padLeft(this.companyPrefix.toString(this.CONVERTBINARY), this.companyPrefixLengthInBits, '0'));
    // append the Item Reference
    binarySgtinEpc += (this.padLeft(this.itemReference.toString(this.CONVERTBINARY), this.itemReferenceLengthInBits, '0'));
    // append the Serial Number
    binarySgtinEpc += (this.padLeft(this.serialNumber.toString(this.CONVERTBINARY), 38, '0'));

    // Return the EPC String in Hexadecimal format
    let bigInt = require("big-integer");
    let epcint = bigInt(binarySgtinEpc, 2);
    console.log(epcint.toString(16));
    return bigInt(binarySgtinEpc, 2).toString(16);
  }

  public ToUpc(): string {
    // Placeholder for building URI String
    let sgtinUpc: string = "";

    sgtinUpc += (this.upc);
    sgtinUpc += (this.upcCheckDigit);
    // Return the URI String
    return sgtinUpc.toString();
  }

  public toEAN(): string {
    // Placeholder for building URI String
    let sgtinUpc: string = "";

    sgtinUpc += this.upc;
    sgtinUpc += this.upcCheckDigit;

    // Return the URI String
    return this.padLeft(sgtinUpc.toString(), 13, '0');
  }

  public IsValidSGTIN(testString: string): boolean {
    let validSGTIN: boolean = false;

    if (testString) {
      // A valid SGTIN has to pass scrutiny either a URI or an EPC
      validSGTIN = this.isValidUri(testString) || this.IsValidEpc(testString);
    }

    return validSGTIN;
  }

  public GetGTIN(inputSGTIN: string): string {
    let returnGTIN: string = "";

    if (!inputSGTIN) {
      throw new Error("Null or Empty SGTIN-96 String.");
    }

    if (this.isValidUri(inputSGTIN)) {
      // It is a URI String, so populate the object data members
      // accordingly
      try {
        let tempSgtin: SGTIN96 = this.fromSgtin96Uri(inputSGTIN);
        tempSgtin.serialNumber = 0;
        returnGTIN = tempSgtin.ToUri();
      }
      catch (ex) {
        throw ex;
      }
    }
    else if (this.IsValidEpc(inputSGTIN)) {
      // It is an EPC String, so populate the object data members
      // accordingly
      try {
        let tempSgtin: SGTIN96 = this.fromSgtin96Epc(inputSGTIN);
        tempSgtin.serialNumber = 0;
        returnGTIN = tempSgtin.ToUri();
      }
      catch (ex) {
        throw ex;
      }
    }
    else {
      throw new Error("Invalid SGTIN-96 String");
    }

    return returnGTIN;
  }

  public GetSGTINZeroValueSerialNumber(): string {
    let returnSgtin: string = "";
    let tempSerialNumber: number = this.serialNumber;
    this.serialNumber = 0;
    returnSgtin = this.ToUri();
    this.serialNumber = tempSerialNumber;
    return returnSgtin;
  }

  public isSameProduct(epc: SGTIN96): boolean {

    // If parameter is null return false.
    if (epc == null) {
      return false;
    }
    return (this.companyPrefix == epc.companyPrefix) &&
      (this.companyPrefixLengthInBits == epc.companyPrefixLengthInBits) &&
      (this.companyPrefixLengthInDigits == epc.companyPrefixLengthInDigits) &&
      (this.itemReference == epc.itemReference) &&
      (this.itemReferenceLengthInBits == epc.itemReferenceLengthInBits) &&
      (this.itemReferenceLengthInDigits == epc.itemReferenceLengthInDigits);
  }

  private isValidUri(CandidateSgtin: string): boolean {
    let ValidUriDetected: boolean = false;
    let DataValues: string[];
    let SgtinCandidate: string = "";

    // Check to make sure that we have data to work with;
    // a null or empty String is invalid. Throw the appropriate
    // exception if this is the case.
    if (CandidateSgtin) {
      SgtinCandidate = CandidateSgtin;

      // Strip out the fixed URI prefix String so that we can look at the data
      let DataFields: string = SgtinCandidate.replace(this.uriPrefix, "");
      // Now, extract each of the remaining fields as a separate String
      DataValues = DataFields.split(".");

      // Define this variable here so that it has scope outside of
      // the IF. Negative logic used so that this value is meaningful
      // in determining the value of ValidUriDetected
      let DataValuesAreNotNumeric: boolean = false;

      // If there are not enough URI fields, return false
      if (4 == DataValues.length) {
        // Ensure that each of the DataValues is numeric

        let IsDigit: RegExp = new RegExp('[\\d]+');
        for (let str of DataValues) {
          if (!IsDigit.test(str)) {
            DataValuesAreNotNumeric = true;
            break;
          }
        }

// Do further sanity checks only if all DataValues are numeric
        if (!DataValuesAreNotNumeric) {
          // First, verify the Filter field
          let FilterField: number = parseInt(DataValues[0], this.CONVERTDECIMAL);

          if (this.filterValueMin <= FilterField
            &&
            this.filterValueMax >= FilterField) {
            // Everything's good so far   , so now check the company
            // prefix and item reference fields.  These must match
            // one of the the following associations
            //
            // Company Prefix Digits | Item Reference Digits
            // -----------------------------------------
            //        12             |          1
            //        11             |          2
            //        10             |          3
            //        9              |          4
            //        8              |          5
            //        7              |          6
            //        6              |          7
            // -----------------------------------------
            // This table can be summarized by verifying that
            // the number of Company Prefix digits is between 6 & 12
            // and that the sum of the Company Prefix digits and
            // Item Reference digits = 13.

            let Prefix: string = DataValues[1];
            let PrefixDigitCount: number = Prefix.length;

            let ItemReference: string = DataValues[2];
            let ItemReferenceDigitCount: number = ItemReference.length;

            let ValidCoPrefixAndItemRef: boolean = false;

            if ((6 <= PrefixDigitCount
                &&
                12 >= PrefixDigitCount)
              &&
              (13 == (PrefixDigitCount + ItemReferenceDigitCount))
            ) {
              ValidCoPrefixAndItemRef = true;
            }

            // Now verify that the serial number is 38 bits or less
            if (ValidCoPrefixAndItemRef) {
              let SerialNumber: string = DataValues[3];
              let SerialNumberAsInt: number = parseInt(SerialNumber, this.CONVERTDECIMAL);
              let SerialNumberBitCount: number = 0;
              let SerialNumberAsBits: string = SerialNumberAsInt.toString(2);

              SerialNumberBitCount = SerialNumberAsBits.length;

              if (this.serialNumberMaxBits >= SerialNumberBitCount) {
                ValidUriDetected = true;
              }
            }
          }
        }
      }
    }
    return ValidUriDetected;
  }


  private IsValidEpc(CandidateSgtin: string): boolean {
    let ValidEpcDetected: boolean = false;

    // Return false immediately if a Null or Empty String is passed in
    if (CandidateSgtin) {
      // Verify that the String has the right number of characters
      // for an EPC
      if (24 == CandidateSgtin.length) {

        // Translate the EPC from a Hex String to a binary String
        let BinaryEpc: string = this.padLeft(parseInt(CandidateSgtin, this.CONVERTHEX).toString(this.CONVERTBINARY), 96, '0');
        let HeaderValue: number;
        let FilterValue: number;
        // Verify that the EPC is represented by 96-bits
        if (96 != BinaryEpc.length) {
          return false;
        }
        else {
          // Verify that the Header is correct
          HeaderValue = parseInt(BinaryEpc.substring(0, 8), this.CONVERTBINARY);
          if (this._header == HeaderValue) {
            // Verify that the Filter is between the min and max values
            FilterValue = parseInt(BinaryEpc.substring(8, 8 + 1), this.CONVERTBINARY);

            if ((this.filterValueMin <= FilterValue
                &&
                this.filterValueMax >= FilterValue)) {
              // Everything's good, so continue and verify the
              // Partition is between min and max values
              let Partition: number = parseInt(BinaryEpc.substring(11, 11 + 3), 2);
              if ((this.partitionValueMin <= Partition
                  &&
                  this.partitionValueMax >= Partition)) {
                // The remainder of the bits are very difficult
                // to verify, so call the EPC good
                ValidEpcDetected = true;
              }
            }
          }
        }
      }
    }
    return ValidEpcDetected;
  }

  private CalculateUpcCheckDigit(UPC: string): number {
    let check: number = 0;

    if (UPC == UPC.replace("[^0-9]", "")) {

      // pad with zeros to lengthen to 13 digits
      UPC = this.padLeft(UPC, 13, '0');

      // evaluate check digit
      let a: number[] = new Array(13);
      a[0] = parseInt(UPC.charAt(0)) * 3;
      a[1] = parseInt(UPC.charAt(1));
      a[2] = parseInt(UPC.charAt(2)) * 3;
      a[3] = parseInt(UPC.charAt(3));
      a[4] = parseInt(UPC.charAt(4)) * 3;
      a[5] = parseInt(UPC.charAt(5));
      a[6] = parseInt(UPC.charAt(6)) * 3;
      a[7] = parseInt(UPC.charAt(7));
      a[8] = parseInt(UPC.charAt(8)) * 3;
      a[9] = parseInt(UPC.charAt(9));
      a[10] = parseInt(UPC.charAt(10)) * 3;
      a[11] = parseInt(UPC.charAt(11));
      a[12] = parseInt(UPC.charAt(12)) * 3;
      let sum: number = a[0] + a[1] + a[2] + a[3] + a[4] + a[5] + a[6] + a[7] + a[8] + a[9] + a[10] + a[11] + a[12];
      check = (10 - (sum % 10)) % 10;
    }

    return check;
  }

  public IsValidGtin(code: string): boolean {
    if (code != code.replace("[^0-9]", "")) {
      // is not numeric
      return false;
    }
// pad with zeros to lengthen to 14 digits
    switch (code.length) {
      case 8:
        code = "000000" + code;
        break;
      case 11:
        code = '000' + code;
        break;
      case 12:
        code = "00" + code;
        break;
      case 13:
        code = "0" + code;
        break;
      case 14:
        break;
      default:
        // wrong number of digits
        return false;
    }
// calculate check digit
    let a: number[] = new Array(13);
    a[0] = parseInt(code.charAt(0)) * 3;
    a[1] = parseInt(code.charAt(1));
    a[2] = parseInt(code.charAt(2)) * 3;
    a[3] = parseInt(code.charAt(3));
    a[4] = parseInt(code.charAt(4)) * 3;
    a[5] = parseInt(code.charAt(5));
    a[6] = parseInt(code.charAt(6)) * 3;
    a[7] = parseInt(code.charAt(7));
    a[8] = parseInt(code.charAt(8)) * 3;
    a[9] = parseInt(code.charAt(9));
    a[10] = parseInt(code.charAt(10)) * 3;
    a[11] = parseInt(code.charAt(11));
    a[12] = parseInt(code.charAt(12)) * 3;
    let sum: number = a[0] + a[1] + a[2] + a[3] + a[4] + a[5] + a[6] + a[7] + a[8] + a[9] + a[10] + a[11] + a[12];
    let check: number = (10 - (sum % 10)) % 10;
// evaluate check digit
    let last: number = parseInt(code.charAt(13));
    return check == last;
  }

  public IsValidUPC(UPC: string): boolean {
    if (UPC != UPC.replace("[^0-9]", "")) {
      // is not numeric
      return false;
    }

// pad with zeros to lengthen to 14 digits
    switch (UPC.length) {
      case 8:
      case 12:
      case 13:
      case 14:
        UPC = this.padLeft(UPC, 14, "0");
        break;
      default:
        // wrong number of digits
        return false;
    }
// evaluate check digit
    let a: number[] = new Array(13);
    a[0] = parseInt(UPC.charAt(0)) * 3;
    a[1] = parseInt(UPC.charAt(1));
    a[2] = parseInt(UPC.charAt(2)) * 3;
    a[3] = parseInt(UPC.charAt(3));
    a[4] = parseInt(UPC.charAt(4)) * 3;
    a[5] = parseInt(UPC.charAt(5));
    a[6] = parseInt(UPC.charAt(6)) * 3;
    a[7] = parseInt(UPC.charAt(7));
    a[8] = parseInt(UPC.charAt(8)) * 3;
    a[9] = parseInt(UPC.charAt(9));
    a[10] = parseInt(UPC.charAt(10)) * 3;
    a[11] = parseInt(UPC.charAt(11));
    a[12] = parseInt(UPC.charAt(12)) * 3;
    let sum: number = a[0] + a[1] + a[2] + a[3] + a[4] + a[5] + a[6] + a[7] + a[8] + a[9] + a[10] + a[11] + a[12];
    let check: number = (10 - (sum % 10)) % 10;
    // evaluate check digit
    let last: number = parseInt(UPC.charAt(13));
    return check == last;
  }

  private SetLengthsFromPartition(sgtin96ToUpdate: SGTIN96): void {
    switch (sgtin96ToUpdate.partition) {
      case 0:
        sgtin96ToUpdate.companyPrefixLengthInBits = 40;
        break;
      case 1:
        sgtin96ToUpdate.companyPrefixLengthInBits = 37;
        break;
      case 2:
        sgtin96ToUpdate.companyPrefixLengthInBits = 34;
        break;
      case 3:
        sgtin96ToUpdate.companyPrefixLengthInBits = 30;
        break;
      case 4:
        sgtin96ToUpdate.companyPrefixLengthInBits = 27;
        break;
      case 5:
        sgtin96ToUpdate.companyPrefixLengthInBits = 24;
        break;
      case 6:
        sgtin96ToUpdate.companyPrefixLengthInBits = 20;
        break;
      default:
        break;
    }
    sgtin96ToUpdate.itemReferenceLengthInBits =
      44 - sgtin96ToUpdate.companyPrefixLengthInBits;
    sgtin96ToUpdate.itemReferenceLengthInDigits =
      1 + sgtin96ToUpdate.partition;
    sgtin96ToUpdate.companyPrefixLengthInDigits =
      13 - sgtin96ToUpdate.itemReferenceLengthInDigits;
  }

  public padLeft(str: string, len: number, ch: string): string {
    len = len - str.length + 1;
    return len > 0 ?
      new Array(len).join(ch) + str : str;
  }


  public formatZeroFilled(int: number, size: number): string {
    let s: string = int + "";
    while (s.length < size) s = "0" + s;
    return s;
  }
}




// WEBPACK FOOTER //
// ./src/models/sgtinencoding/epc-utils.ts